<template>
  <PostcodeInput
    v-model="postcodeInput"
    v-on-clickaway="handleBlur"
    :fixed="fixed"
    :container="container"
    :status="status"
    :has-error="error"
    :focus-key="focusKey"
    :is-mobile="isMobile"
    :is-tablet="isTablet"
    :is-homepage="isHomepage"
    :button-label="'Start Quote'"
    :show-search-icon="showSearchIcon"
    :icon="icon"
    :icon-hover="iconHover"
    @submit="checkPostcode"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway'
import PostcodeInput from './PostcodeInput'
import InputRegexes from '../mixins/InputRegexes'
import Routable from '../mixins/Routable'

export default {
  name: 'BasicPostcodeInput',

  components: { PostcodeInput },

  mixins: [InputRegexes, Routable, clickaway],

  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    container: {
      type: Boolean,
      default: false
    },
    isHomepage: {
      type: Boolean,
      default: false
    },
    buttonLabel: {
      type: String,
      default: 'Start quote'
    },
    showSearchIcon: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    iconHover: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      error: false,
      focusKey: false,
      postcodeInput: ''
    }
  },

  computed: {
    ...mapGetters(['isMobile', 'isTablet']),

    status () {
      return 'ready'
    }
  },

  methods: {
    checkPostcode () {
      this.error = false

      if (!this.postcodeInput.match(this.postcodeRegex)) {
        this.error = true
        return
      }
      this.$emit('submit', this.postcodeInput)
    },

    focusInput () {
      this.focusKey = !this.focusKey
    },

    handleBlur () {
      this.error = false
      if (!this.postcodeInput.match(this.postcodeRegex)) {
        this.error = true
      }
    }
  }
}
</script>
